import { Helmet } from "react-helmet-async";
import { SITE } from "@/data/site";

export default function Seo({
    title,
    description = SITE.description,
    path = "/",
    image = `${SITE.url}/og-default.png`,
    type = "website",
    noindex = false,
}) {
    const fullTitle = title ? `${title} — ${SITE.name}` : `${SITE.name} — ${SITE.slogan}`;
    const canonical = `${SITE.url}${path}`;
    return (
        <Helmet>
            <html lang="pl" />
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={canonical} />
            {noindex && <meta name="robots" content="noindex,nofollow" />}
            <link rel="alternate" hrefLang="pl" href={canonical} />
            <link rel="alternate" hrefLang="x-default" href={canonical} />

            <meta property="og:type" content={type} />
            <meta property="og:site_name" content={SITE.name} />
            <meta property="og:locale" content="pl_PL" />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonical} />
            <meta property="og:image" content={image} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
}
